import { notifierSlice } from "../slices/notifierSlice";

export const { addNotification, removeNotification } = notifierSlice.actions;
